import * as R from 'ramda'
import { DocusignDocumentType } from '@/modules/Envelop/interfaces/envelop-detail'

export const docusignDocumentTypeKeys = R.keys(DocusignDocumentType)
export const docusignDocumentTypeValues = R.values(DocusignDocumentType)
